<div class="swipe-page" (click)="closeAllPanels()">
  <div class="swipe-header">
    <button class="back-nav-btn" (click)="goBack()" title="Back to Home">
      <svg viewBox="0 0 24 24" class="back-icon">
        <path d="M19 12H5"></path>
        <path d="M12 19l-7-7 7-7"></path>
      </svg>
    </button>

    <button
      class="stats-toggle-btn"
      (click)="toggleStatsPanel(); $event.stopPropagation()"
      *ngIf="!isLoading && !error && isMobile"
      title="View Stats"
    >
      <svg viewBox="0 0 24 24" class="stats-icon">
        <path d="M12 20v-6M6 20V10M18 20V4"></path>
      </svg>
    </button>
  </div>

  <div class="swipe-sidebar-left" *ngIf="!isLoading && !error && !isMobile">
    <div class="stats-widget">
      <div class="stat-item" *ngIf="stats">
        <span class="stat-value">{{ stats.total_wishlist_count }}</span>
        <span class="stat-label">Wishlisted</span>
      </div>
    </div>

    <div class="category-widget">
      <div class="widget-title">Filters</div>
      <div class="filter-buttons">
        <button
          *ngFor="let category of availableCategories"
          class="filter-btn"
          [class.active]="selectedCategories.includes(category.key)"
          (click)="toggleCategory(category.key)"
          [disabled]="isLoading"
          [title]="category.label"
        >
          <svg viewBox="0 0 24 24" class="filter-icon">
            <path
              *ngIf="category.icon === 'car'"
              d="M3 13l1.5-4.5A2 2 0 0 1 6.4 7h11.2a2 2 0 0 1 1.9 1.5L21 13"
            ></path>
            <path
              *ngIf="category.icon === 'car'"
              d="M5 16h14a2 2 0 0 0 2-2v-1H3v1a2 2 0 0 0 2 2z"
            ></path>
            <circle
              *ngIf="category.icon === 'car'"
              cx="7.5"
              cy="16.5"
              r="1.5"
            ></circle>
            <circle
              *ngIf="category.icon === 'car'"
              cx="16.5"
              cy="16.5"
              r="1.5"
            ></circle>

            <path
              *ngIf="category.icon === 'home'"
              d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
            ></path>
            <polyline
              *ngIf="category.icon === 'home'"
              points="9 22 9 12 15 12 15 22"
            ></polyline>

            <path
              *ngIf="category.icon === 'shopping-bag'"
              d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"
            ></path>
            <line
              *ngIf="category.icon === 'shopping-bag'"
              x1="3"
              y1="6"
              x2="21"
              y2="6"
            ></line>
            <path
              *ngIf="category.icon === 'shopping-bag'"
              d="M16 10a4 4 0 0 1-8 0"
            ></path>

            <rect
              *ngIf="category.icon === 'briefcase'"
              x="2"
              y="7"
              width="20"
              height="14"
              rx="2"
              ry="2"
            ></rect>
            <path
              *ngIf="category.icon === 'briefcase'"
              d="M16 3h-8v4h8V3z"
            ></path>
          </svg>
        </button>
      </div>
    </div>
  </div>

  <div class="swipe-container">
    <div class="loading-container" *ngIf="isLoading">
      <div class="loading-spinner"></div>
      <p class="loading-text">Finding listings...</p>
    </div>

    <div class="refresh-indicator" [class.show]="isRefreshing">
      <div class="refresh-spinner"></div>
      <p class="refresh-text">Refreshing...</p>
    </div>

    <div class="error-container" *ngIf="error && !isLoading">
      <div class="error-icon">⚠️</div>
      <h3 class="error-title">Something went wrong</h3>
      <p class="error-message">{{ error }}</p>
      <button class="retry-button" (click)="loadInitialData()">
        Try Again
      </button>
    </div>

    <div
      class="no-more-container"
      *ngIf="!isLoading && !error && !currentListing && !hasMoreListings"
    >
      <div class="no-more-icon">🎉</div>
      <h3 class="no-more-title">All caught up!</h3>
      <p class="no-more-message">
        You've seen all available listings. Check back later for new items!
      </p>
      <div class="no-more-actions">
        <button class="reset-btn" (click)="resetSession()">
          <svg viewBox="0 0 24 24" class="reset-icon">
            <path d="M1 4v6h6"></path>
            <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>
          </svg>
          Start Over
        </button>
        <a routerLink="/wishlist" class="wishlist-link"> View Wishlist </a>
      </div>
    </div>

    <div
      class="swipe-card"
      #swipeCard
      *ngIf="!isLoading && !error && currentListing"
      (touchstart)="onTouchStart($event)"
      (touchmove)="onTouchMove($event)"
      (touchend)="onTouchEnd($event)"
      (mousedown)="onMouseDown($event)"
      [class.dragging]="isDragging"
    >
      <div class="card-image-container">
        <img
          [src]="getCurrentImage()"
          [alt]="currentListing.title"
          class="card-image"
          (error)="onImageError($event)"
        />

        <div
          class="image-nav-zone left-zone"
          (click)="previousImage($event)"
          (touchstart)="onImageTouchStart($event, 'left')"
          (touchend)="onImageTouchEnd($event, 'left')"
          *ngIf="currentListing.image_count > 1"
        ></div>
        <div
          class="image-nav-zone right-zone"
          (click)="nextImage($event)"
          (touchstart)="onImageTouchStart($event, 'right')"
          (touchend)="onImageTouchEnd($event, 'right')"
          *ngIf="currentListing.image_count > 1"
        ></div>

        <button
          class="wishlist-heart-btn"
          [class.wishlisted]="isCurrentListingWishlisted"
          (click)="toggleWishlistFromHeart($event)"
          (touchstart)="onHeartTouchStart($event)"
          (touchend)="onHeartTouchEnd($event)"
          [disabled]="isProcessingHeart"
        >
          <svg viewBox="0 0 24 24" class="heart-icon">
            <path
              d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
            ></path>
          </svg>
        </button>

        <div class="image-dots" *ngIf="currentListing.image_count > 1">
          <div
            *ngFor="let image of getImageArray(); let i = index"
            class="image-dot"
            [class.active]="i === currentImageIndex"
            (click)="goToImage(i, $event)"
            (touchstart)="onDotTouchStart($event, i)"
            (touchend)="onDotTouchEnd($event, i)"
          ></div>
        </div>

        <div class="image-count-badge" *ngIf="currentListing.image_count > 1">
          <svg viewBox="0 0 24 24" class="camera-icon">
            <path
              d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"
            ></path>
            <circle cx="12" cy="13" r="4"></circle>
          </svg>
          {{ currentImageIndex + 1 }}/{{ currentListing.image_count }}
        </div>

        <div class="featured-badge" *ngIf="currentListing.is_featured">
          Featured
        </div>

        <div class="new-badge" *ngIf="isNewListing(currentListing)">New</div>
      </div>

      <div class="card-content">
        <div class="card-header">
          <h3 class="card-title">{{ currentListing.title }}</h3>
          <div class="card-price">
            {{ formatPrice(currentListing.price, currentListing.currency) }}
          </div>
        </div>

        <div class="card-meta">
          <div class="card-category">
            <svg viewBox="0 0 24 24" class="category-icon">
              <path d="M20 6L9 17l-5-5"></path>
            </svg>
            {{ getCategoryDisplayName(currentListing.table_name) }}
          </div>

          <div class="card-location" *ngIf="currentListing.location">
            <svg viewBox="0 0 24 24" class="location-icon">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
              <circle cx="12" cy="10" r="3"></circle>
            </svg>
            {{ currentListing.location }}
          </div>
        </div>

        <div class="card-seller">
          <svg viewBox="0 0 24 24" class="user-icon">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
          {{ currentListing.first_name }} {{ currentListing.last_name }}
        </div>
      </div>
    </div>
  </div>

  <div
    class="mobile-panel filters-panel"
    [class.show]="showFiltersPanel"
    (click)="$event.stopPropagation()"
    *ngIf="isMobile"
  >
    <div class="panel-handle" (click)="toggleFiltersPanel()"></div>
    <div class="panel-content">
      <div class="panel-header">
        <h3 class="panel-title">Filter Categories</h3>
        <button class="panel-close" (click)="toggleFiltersPanel()">
          <svg viewBox="0 0 24 24" class="close-icon">
            <path d="M18 6L6 18"></path>
            <path d="M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <div class="mobile-filter-grid">
        <button
          *ngFor="let category of availableCategories"
          class="mobile-filter-btn"
          [class.active]="selectedCategories.includes(category.key)"
          (click)="toggleCategory(category.key)"
          [disabled]="isLoading"
        >
          <svg viewBox="0 0 24 24" class="filter-icon">
            <path
              *ngIf="category.icon === 'car'"
              d="M3 13l1.5-4.5A2 2 0 0 1 6.4 7h11.2a2 2 0 0 1 1.9 1.5L21 13"
            ></path>
            <path
              *ngIf="category.icon === 'car'"
              d="M5 16h14a2 2 0 0 0 2-2v-1H3v1a2 2 0 0 0 2 2z"
            ></path>
            <circle
              *ngIf="category.icon === 'car'"
              cx="7.5"
              cy="16.5"
              r="1.5"
            ></circle>
            <circle
              *ngIf="category.icon === 'car'"
              cx="16.5"
              cy="16.5"
              r="1.5"
            ></circle>

            <path
              *ngIf="category.icon === 'home'"
              d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
            ></path>
            <polyline
              *ngIf="category.icon === 'home'"
              points="9 22 9 12 15 12 15 22"
            ></polyline>

            <path
              *ngIf="category.icon === 'shopping-bag'"
              d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"
            ></path>
            <line
              *ngIf="category.icon === 'shopping-bag'"
              x1="3"
              y1="6"
              x2="21"
              y2="6"
            ></line>
            <path
              *ngIf="category.icon === 'shopping-bag'"
              d="M16 10a4 4 0 0 1-8 0"
            ></path>

            <rect
              *ngIf="category.icon === 'briefcase'"
              x="2"
              y="7"
              width="20"
              height="14"
              rx="2"
              ry="2"
            ></rect>
            <path
              *ngIf="category.icon === 'briefcase'"
              d="M16 3h-8v4h8V3z"
            ></path>
          </svg>
          <span class="filter-label">{{ category.label }}</span>
        </button>
      </div>

      <div class="panel-actions">
        <button
          class="clear-filters-btn"
          (click)="selectedCategories = []; toggleFiltersPanel()"
          *ngIf="selectedCategories.length > 0"
        >
          Clear All Filters
        </button>
      </div>
    </div>
  </div>

  <div
    class="mobile-panel stats-panel"
    [class.show]="showStatsPanel"
    (click)="$event.stopPropagation()"
    *ngIf="isMobile"
  >
    <div class="panel-handle" (click)="toggleStatsPanel()"></div>
    <div class="panel-content">
      <div class="panel-header">
        <h3 class="panel-title">Your Stats</h3>
        <button class="panel-close" (click)="toggleStatsPanel()">
          <svg viewBox="0 0 24 24" class="close-icon">
            <path d="M18 6L6 18"></path>
            <path d="M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <div class="mobile-stats-grid">
        <div class="mobile-stat-card">
          <div class="stat-value">{{ stats.total_wishlist_count }}</div>
          <div class="stat-label">Wishlisted Items</div>
        </div>
      </div>

      <button class="wishlist-link-btn" routerLink="/wishlist">
        View Full Wishlist
      </button>
    </div>

    <button
      class="mobile-action-btn filter-btn"
      (click)="toggleFiltersPanel(); $event.stopPropagation()"
      [class.active]="showFiltersPanel"
    >
      <svg viewBox="0 0 24 24" class="action-icon">
        <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z"></path>
      </svg>
      <span class="action-label">Filters</span>
    </button>
  </div>

  <div
    class="swipe-instructions"
    *ngIf="!isLoading && !error && currentListing && !isMobile"
  >
    <div class="instruction-item">
      <svg viewBox="0 0 24 24" class="instruction-icon">
        <path d="M15 18l-6-6 6-6"></path>
      </svg>
      <span>Swipe left to view</span>
    </div>
    <div class="instruction-item">
      <svg viewBox="0 0 24 24" class="instruction-icon">
        <path d="M18 15l-6-6-6 6"></path>
      </svg>
      <span>Swipe up for next</span>
    </div>
    <div class="instruction-item">
      <svg viewBox="0 0 24 24" class="instruction-icon">
        <path d="M6 9l6 6 6-6"></path>
      </svg>
      <span>Swipe down to refresh</span>
    </div>
  </div>

  <div
    class="panel-overlay"
    [class.show]="showFiltersPanel || showStatsPanel"
    (click)="closeAllPanels()"
  ></div>
</div>
